import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PathDoc, PathRxdbService } from '../../core/services';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core/app-state';
import {BehaviorSubject, Subscription} from 'rxjs';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import {RxDocument, RxDocumentBase} from "rxdb";
import {Path, PathView} from "../../core/models";
import { RxdbPathsEditComponent } from '../rxdb-paths-edit/rxdb-paths-edit.component';

@Component({
  selector: 'app-rxdb-paths-view',
  templateUrl: './rxdb-paths-view.component.html',
  styleUrls: ['./rxdb-paths-view.component.css']
})
export class RxdbPathsViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  isLoading : boolean = false;
  errorMsg: string = "";
  bSyncing: boolean = false;

  constructor(appState: AppState,
    private rxPathService : PathRxdbService,
    private modalService: BsModalService,
    private router: Router ) {
    super(appState)
  }

  ngOnInit(): void {
    this.rxPathService.doWhenReady( () => this.loadPaths() )
  }

  ngOnDestroy(): void {
    this.destroy()
    this.pathSubscription?.unsubscribe()
  }

  rxPaths : PathDoc[] = []
  pathSubscription: Subscription;

  async loadPaths() {
    this.errorMsg = ""
    this.rxPaths = []
    this.isLoading = true
    try {

      const pathSubject = this.rxPathService.rxCollection.find().$;
      this.pathSubscription?.unsubscribe();
      this.pathSubscription = pathSubject.subscribe( (paths)=>{
        this.rxPaths= paths
        this.isLoading=false;
      });
    } catch ( error ) {
      this.errorMsg = this.rxPathService.extractErrorMsg(error)
    }
  }

  async clearPaths() {
    let initialState = {
      onYes: async () => {
        await this.rxPathService.rxCollection.remove().then(async () => {
          console.log('rxCollection remove()')
        }).catch(error => {
          console.log('clearPaths() Error: ', error)
        }).finally(() => {
          // location.reload()
          this.router.navigate(['']).then(() => {
            location.reload();
          });
        })
      },
      title: "RxDB Paths Rebuild",
      question: `Do you wish to rebuild Path Database?  `
        + `<div class="m-2 small font-italic text-warning"><i class='text-warning fa fa-info-circle mr-1'></i>It may take a few minutes to re-sync Path Data</div>`
        + `<div>Rebuild now?</div>`,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.show(ConfirmModalComponent, {ignoreBackdropClick: true,initialState} );
  }

  async editPath(pathDoc: PathDoc) {
    const initialState = {
      path: pathDoc
    }
    this.modalService.show(RxdbPathsEditComponent, {ignoreBackdropClick: true, initialState});
  }

}
